function readRaw() {
  return sessionStorage.getItem("services_enable") ?? "";
}

function normalizeFlag(value) {
  if (value == null) return "";
  if (typeof value === "string") return value.trim().toUpperCase();
  if (typeof value === "object") {
    const candidate =
      value.name ?? value.code ?? value.service ?? value.value ?? value.type;
    return typeof candidate === "string" ? candidate.trim().toUpperCase() : "";
  }
  return String(value).trim().toUpperCase();
}

function uniq(values) {
  return [...new Set(values.filter(Boolean))];
}

export function getServicesEnable() {
  const raw = readRaw();

  try {
    if (!raw) return [];

    let flags = [];

    if (Array.isArray(raw)) {
      flags = raw.map(normalizeFlag);
    } else if (typeof raw === "string") {
      const text = raw.trim();

      if (!text) return [];

      if (text.startsWith("[") || text.startsWith("{")) {
        try {
          const parsed = JSON.parse(text);
          if (Array.isArray(parsed)) {
            flags = parsed.map(normalizeFlag);
          } else {
            flags = [normalizeFlag(parsed)];
          }
        } catch {
          flags = text
            .replace(/[\[\]{}\"']/g, "")
            .split(/[,;\s]+/)
            .map(normalizeFlag);
        }
      } else {
        flags = text.split(/[,;\s]+/).map(normalizeFlag);
      }
    } else {
      flags = [normalizeFlag(raw)];
    }

    return uniq(flags);
  } catch {
    return [];
  }
}

export function hasRampsEnabled() {
  const flags = getServicesEnable();
  if (flags.includes("ALL")) return true;
  return flags.includes("RAMP") || flags.includes("RAMPS");
}

export function hasBaasEnabled() {
  const flags = getServicesEnable();
  if (flags.includes("ALL")) return true;
  return flags.includes("BAAS");
}

// Task 37: sem atalho `ALL` — diferente de hasRampsEnabled/hasBaasEnabled (pré-existentes,
// onde `ALL` é o comportamento vigente que clientes em produção dependem hoje),
// hasSwapEnabled nasceu nesta branch. `getServicesEnable()` pode devolver `["ALL"]` pelo
// caminho de compatibilidade legada (fora deste arquivo), e a decisão do dono do produto é
// que só BAAS abre de saída: swap, rampa e custódia o compliance libera um a um, na tela. O
// atalho abriria o menu de Swap para quem não foi liberado, e a recusa só chegaria depois
// do cliente preencher e enviar a cotação (403 do servidor).
export function hasSwapEnabled() {
  const flags = getServicesEnable();
  return flags.includes("SWAP");
}

// Task 37: mesma razão de hasSwapEnabled acima — e sem consumidor algum hoje, então deixar
// o atalho `ALL` aqui seria plantar o mesmo defeito para quando ganhar um.
export function hasCustodyEnabled() {
  const flags = getServicesEnable();
  return flags.includes("CUSTODY");
}

export function persistServicesEnable(flags) {
  if (!Array.isArray(flags)) return;
  try {
    sessionStorage.setItem("services_enable", JSON.stringify(flags));
  } catch {}
}

// Task 30: chave própria para o `enable` legado (raiz da resposta de login, irmão de
// servicesEnable — ver ShowOnboardingStatus.cs), desacoplada de `services_enable`. A carga
// de dados desta branch concede BAAS a todos os clientes existentes, o que faria
// `services_enable` conter "BAAS" para todo mundo; isMutual() precisa continuar refletindo
// o comportamento de hoje (produto de origem do cliente), não a lista de produtos liberados.
export function persistEnableLegacy(enable) {
  try {
    sessionStorage.setItem(
      "enable_legacy",
      String(enable ?? "").toUpperCase(),
    );
  } catch {}
}

export function getEnableLegacy() {
  // Task 34: `null` ("nunca escrita" — sessão aberta antes do deploy) e `""` ("limpa no
  // logout", ver utilService.logout) são estados diferentes para isMutual(); `|| ""` os
  // fundia. Devolve o valor cru de sessionStorage para que o chamador possa distingui-los.
  return sessionStorage.getItem("enable_legacy");
}

// Task 34: leitura crua de `services_enable`, sem o parsing de getServicesEnable() — usada
// só pela regra de migração de isMutual() (ver ali), que precisa espelhar exatamente o
// texto que `main` compara hoje (`raw.toUpperCase().includes("BAAS")`), não a lista
// normalizada.
export function getServicesEnableRaw() {
  return sessionStorage.getItem("services_enable");
}
